import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { fieldIsRequired } from '../../utils/forms.utils';

@Component({
  selector: 'app-text-input',
  templateUrl: './text-input.component.html',
  styleUrl: './text-input.component.scss',
})
export class TextInputComponent {
  @Input({ required: true }) control!: FormControl<string | null>;
  @Input({ required: true }) label!: string;

  isRequired = fieldIsRequired;
}
